import { Component, ElementRef, HostListener, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import {gsap} from 'gsap';
import { CursorService } from 'src/app/services/cursor_animation/cursor.service';

@Component({
    selector: 'app-nav-red-logo',
    templateUrl: './nav-red-logo.component.html',
    styleUrls: ['./nav-red-logo.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class NavRedLogoComponent implements OnInit {
  @ViewChild('offcanvasNavbar') offcanvasNavbar!: ElementRef ;
  logoScrolled: boolean = false;

  constructor(private cursorService: CursorService) {

  }
  ngOnInit(): void {
  }
  ngAfterViewInit(): void {
    const navbar = this.offcanvasNavbar.nativeElement
    const observer = new MutationObserver(mutations => {
      mutations.forEach((mutation:any) => {
        if (mutation.attributeName === 'class' && mutation.target.classList.contains('hiding')) {
          gsap.to(".nav-link", {
            opacity: 1,
            x: 300, 
            duration: 0.5,
            ease: "power2.out",
            // visibility: "hidden",
            stagger: {
              amount: 0.5, // Base stagger amount
              from: "end" // Controls where the stagger starts
            },
            onComplete: () =>{
              gsap.set(".nav-link", { visibility: "hidden" });
            }
          });
        }
      });
    });

    observer.observe(navbar, { attributes: true });
  }


  onMouseEnter(): void {
    this.cursorService.hoverElement();
  }

  onMouseLeave(): void {
    this.cursorService.unhoverElement();
  }
  slideNavlinks(){
    if (this.offcanvasNavbar) {
      gsap.to(".nav-link", {
        opacity: 1,
        x: 0,
        duration: 0.5,
        stagger: {
          amount: 1, // Base stagger amount
          from: "start" // Controls where the stagger starts
        },
        ease: "power2.out",
        visibility: "visible"
      });
    }
  }
}
